import { Injectable } from '@angular/core';
import {
	NgbDateParserFormatter,
	NgbDateStruct
}                     from '@ng-bootstrap/ng-bootstrap';
import { DateUtils }  from '@utils/helpers';

/** Custom service for date formatting in the datepicker input field */
@Injectable()
export class CustomDateTimeFormatter extends NgbDateParserFormatter {

	private _formatter: Intl.DateTimeFormat;

	set formatterOptions( formatterOptions: { dateFormat: Intl.DateTimeFormatOptions; locale: string } ) {
		const { dateFormat, locale } = formatterOptions ?? {};
		this._formatter = new Intl.DateTimeFormat( locale, dateFormat ) ;
	}

  constructor() {
		super();
	}

	parse( value: string ): NgbDateStruct | null { return null; }

	format( date: NgbDateStruct | null ): string {
		return this._formatter?.format( DateUtils.ngbDateStructToDate( date ) ) ?? '';
	}
}
